import styles from "./assigneeList.module.scss";
import { Text } from "@medoma/components/Text/Text";
import {
  medicalCompetenceDictionary,
  employeeName,
} from "@medoma/models/shifts";
import type { IAssignedShift } from "@/api/schedule";
import Portrait from "@medoma/components/Portrait/Portrait";
import { useLingui } from "@lingui/react/macro";
import { useUserProfile } from "@/utils/useUserProfile";
import { countryOfOperation } from "@medoma/models/organizations";

const Assignee = ({ shift }: { shift: IAssignedShift }) => {
  const { organization } = useUserProfile();
  const countryCode = countryOfOperation(organization);
  const { employee } = shift;
  const { t } = useLingui();
  const displayName = employeeName(employee, {
    countryCode,
    viewer: "patient",
  });
  const medicalCompetence = t(
    medicalCompetenceDictionary[employee.competence ?? shift.competence].long,
  );

  return (
    <li key={shift.id} className={styles.employee}>
      <Portrait name={displayName} photoUrl={employee.imageURL} size="large" />
      <div>
        <Text element="div">{displayName}</Text>
        <Text element="div" size="small">
          {medicalCompetence}
        </Text>
      </div>
    </li>
  );
};

export const AssigneeList = ({
  assignees,
}: {
  assignees: IAssignedShift[];
}) => (
  <ul className={styles.employeeList}>
    {assignees.map((shift) => (
      <Assignee key={shift.id} shift={shift} />
    ))}
  </ul>
);
